import mongoose from 'mongoose';
import service, { IServiceDocument } from '../schemas/service';

export default (mongoose.models.Service ||
  mongoose.model<IServiceDocument>('Service', service)) as mongoose.Model<IServiceDocument>;
